import src from "IMAGE";
export default { src, width: 300, height: 68, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAcOCCQGCwc4BQkGLggQCSkIEQkTBw8IEQcPCA8ECAQJAA0XDk4FBQWGBAQEdwYHBmcYKhoyGi4cKxsuHS0NFw4WnhcF0uti6HsAAAAASUVORK5CYII="};
